// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"c7c4dbbe","238":"08d26c9e","336":"616392c8","338":"4f106aa7","358":"57f0730c","442":"28ce1a88","508":"0240e205","551":"b456a5e9","629":"1a3c0d4f","645":"f3ef4c8a","828":"b5890c0e"}[chunkId] + ".chunk.js";
};